import * as React from 'react';

import Icon from '../icon';
import {
	Root,
	ContentLayout,
	IconLayout,
} from './styled';


type ListPlaceholderLayoutProps = {
	padding?: number | string;
}

const ListPlaceholderLayout: React.SFC<ListPlaceholderLayoutProps> = props => {
	const { padding, children } = props;

	return (
		<Root padding={padding}>
			<IconLayout>
				<Icon
					width={55}
					height={61}
					type='list-placeholder'
					color='primary' />
			</IconLayout>
			<ContentLayout>
				{children}
			</ContentLayout>
		</Root>
	);
};

const ListPlaceholder = {
	Layout: ListPlaceholderLayout
};

export default ListPlaceholder;
